import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { TreeviewModule } from 'ngx-treeview';
import { documentReducer } from './state/document.reducer';
import { DocumentEffects } from './state/document.effects.';
import { HttpClientModule } from '@angular/common/http';
import { EntityDocumentTreeListComponent } from './entity-document-tree-list/entity-document-tree-list.component';
import { DocumentService } from './entity-document-tree.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SpinnerIconComponent } from './spinner-icon/spinner-icon.component';


@NgModule({
  declarations: [EntityDocumentTreeListComponent, SpinnerIconComponent],
  entryComponents: [EntityDocumentTreeListComponent, SpinnerIconComponent],
  imports: [
    CommonModule,
    FontAwesomeModule,
    TreeviewModule.forRoot(),
    StoreModule.forFeature('entityDocument', documentReducer),
    EffectsModule.forFeature([DocumentEffects]),
  ],
   exports: [
    EntityDocumentTreeListComponent 
  ],
  providers: [DocumentService],
})
export class EntityDocumentTreeModule { }
